import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import theme from '@ifca-root/react-component/src/assets/theme'
import { UploadPreview } from '@ifca-root/react-component/src/components/Avatar/UploadPreview'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { FileUploadInput } from '@ifca-root/react-component/src/components/Input/FileUploadInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import {
  Divider,
  Grid,
  IconButton,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Switch,
  TextField,
} from '@material-ui/core'
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  MoreVert,
  Visibility as VisibilityIcon,
} from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import { Autocomplete, createFilterOptions } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { AccountFooter } from 'components/Footer/AccountFooter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  ApprovalStatus,
  useAssetRegistrationEntryMutation,
  useDocumentListingLazyQuery,
  useGetAccountPeriodQuery,
  useGetFaCategoryDropdownListingQuery,
  useGetFaDepreciationQuery,
  useGetFaLocationQuery,
  useGetFaSourceQuery,
  useGetFieldsSettingLazyQuery,
  useGetFieldsSettingTemplateQuery,
  useGetSelectedAccountPeriodLazyQuery,
  useGetUomQuery,
  useLatestOpenPeriodCheckingDateQuery,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import {
  formatDashDate,
  formatDate,
} from 'helpers/StringNumberFunction/FormatDate'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import { CommonYupValidation } from 'helpers/YupSchema/yup'
import React, { useContext, useEffect, useState, useMemo } from 'react'
import { Controller, useForm } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import * as yup from 'yup'
import { AssetsRegisterAddInfoComponent } from './AssetsRegistrationComponent/AssetsRegisterAddInfoComponent'
import { AssetsRegisterDepreciationComponent } from './AssetsRegistrationComponent/AssetsRegisterDepreciationComponent'
import { AssetsRegisterUsedDepartment } from './AssetsRegistrationComponent/AssetsRegisterUsedDepartment'
import './AssetsRegistrationComponent/AssetsRegistration.scss'
interface AssetsRegistrationProps {
  CompanyID: string
  AssetsRegistrationID: string
  RegistrationDate: string
  StartUsingDate: string
  AssetCardNo: string
  AssetName: string
  AssetCategoryID: string
  SourceID: string
  BaseOriginalAmount: number
  UnitPrice: number
  Quantity: number
  Residual: number
  ResidualValue: number
  NetAmount: number
  UOMID: string
  ModelNo: string
  ReferenceNo: string
  Remarks: string
  Depreciable?: boolean
  MethodID: string
  StartYear: any
  StartPeriod: any
  DepreciationAmt: number
  UsefulLife: number
  UtilizedUsefulLife: number
  AdditionalInformation?: boolean
  TemplateID: string
}

export const AssetsRegistrationForm = (props: any) => {
  let history = useHistory()
  let location = useLocation()
  const editData: any = location?.state
  const { formMode, type } = props
  const CompanyID = localStorage.getItem('latestCompany')
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { AssetsRegistrationID }: any = useParams()
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false)
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const [val, setVal] = useState(false)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [openExitConf, setOpenExitConf] = useState(null)
  const [initDocs, setInitDocs] = useState([])
  const [openUsedDepartment, setOpenUsedDepartment] = useState<boolean>(false)
  const [DepartmentMode, setDepartmentMode] = useState('')
  const [isSubmit, setIsSubmit] = useState(false)
  const [isValid, setIsValid] = useState(true)
  const [accPeriodYears, setAccPeriodYears] = useState(new Set())
  const [record, setRecord] = useState(false)
  const [, setIsFormDirty] = useState(true)
  const [openAdditonalInfo, setOpenAdditionalInfo] = useState<boolean>(false)
  const [AdditonalInfoMode, setAdditionalInfoMode] = useState('')

  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }
  const [usedDepartmentDataState, setUsedDepartmentData] = useState(
    editData?.UsedDepartment
      ? editData?.UsedDepartment?.map((item, index) => {
          return {
            AssetsRegistrationID: undefined,
            CostCentreCode: item?.CostCentre?.Code,
            CostCentreID: item?.cost_centre_id,
            CostCentreName: item?.CostCentre?.Name,
            LocationName: item?.Location?.Name,
            Quantity: item?.quantity,
            Sequence: index,
            UOMID: item?.UOM?.Code,
            UsedDepartmentID: item?.fa_used_department_id,
            fa_location_id: item?.Location?.fa_location_id,
          }
        })
      : []
  )
  const [additionalInfoDataState, setAdditionalInfoData] = useState(() => {
    if (mode === 'edit' && editData?.AdditionalFieldsValue?.length > 0) {
      return (
        editData.AdditionalFieldsValue[0]?.Details?.map(item => ({
          Name: item?.FieldsSettingDetail?.name,
          sequence_no: item?.FieldsSettingDetail?.sequence_no,
          value: item?.value_date ?? item?.value_number ?? item?.value_text,
          is_subgroup: item?.FieldsSettingDetail?.is_subgroup,
          data_type: item?.FieldsSettingDetail?.data_type,
          control_type: item?.FieldsSettingDetail?.control_type,
          fa_fields_setting_detail_id:
            item?.FieldsSettingDetail?.fa_fields_setting_detail_id,
          fa_additional_fields_value_detail_id:
            item?.fa_additional_fields_value_detail_id,
          fa_additional_fields_value_id: item?.fa_additional_fields_value_id,
        })) || []
      )
    }
    return []
  })

  const [errDialog, setErrDialog] = useState(false)
  const [errMessage, setErrMessage] = useState(null)
  const [selectedAssetCategory, setSelectedAssetCategory] = useState(null)
  const [AssetCategoryID, setAssetCategoryID] = useState(
    mode === 'edit' ? editData?.fa_category_id : ''
  )
  const [selectedSource, setSelectedSource] = useState(null)
  const [SourceID, setSourceID] = useState(
    mode === 'edit' ? editData?.fa_source_id : ''
  )
  const [selectedUOM, setSelectedUOM] = useState(null)
  const [fetchUOMID, setFetchUOMID] = useState(
    mode === 'edit' ? editData?.uom_id : ''
  )
  const [isDepreciable, setIsDepreciable] = useState(
    editData ? editData?.is_depreciable : false
  )

  const [selectedMethod, setSelectedMethod] = useState(null)

  const [MethodID, setMethodID] = useState(
    mode === 'edit' ? editData?.fa_depreciation_method_id : ''
  )

  const [StartYear, setStartYear] = useState(
    mode === 'edit' ? editData?.depreciation_start_year : ''
  )

  const [StartPeriod, setStartPeriod] = useState(
    mode === 'edit' ? editData?.depreciation_start_period : ''
  )

  const [usefulLife, setUsefulLife] = useState(
    amtNumStr(
      AssetsRegistrationID && editData?.opening_depreciation_useful_life
    ) ?? 0
  )

  const [utilizedUsefulLife, setUtilizedUsefulLife] = useState(
    amtNumStr(
      AssetsRegistrationID && editData?.depreciation_utilized_useful_life
    ) ?? 0
  )

  const [depreciationAmt, setDepreciationAmt] = useState(
    amtNumStr(
      AssetsRegistrationID && editData?.opening_accumulated_depreciation
    ) ?? 0
  )

  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [templateID, setTemplateID] = useState(() => {
    if (mode === 'edit' && editData?.AdditionalFieldsValue?.length > 0) {
      return editData.AdditionalFieldsValue[0]?.fa_fields_setting_id
    }
    return ''
  })

  /* -------------------------------------------- */
  /*            CALCULATION/VARIABLE              */
  /* -------------------------------------------- */

  const calcTotalQuantity = (currentList: any[]) => {
    return currentList?.reduce((sum, department) => {
      return sum + department.Quantity
    }, 0)
  }

  const calcApportionmentPercentages = (departments: any[]): number[] => {
    if (!departments || departments.length === 0) return []

    const totalQty = departments.reduce((sum, d) => sum + (d.Quantity || 0), 0)
    if (totalQty <= 0) return departments.map(() => 0)

    const percentages: number[] = []
    let runningTotal = 0

    for (let i = 0; i < departments.length; i++) {
      const deptQty = departments[i].Quantity || 0

      if (i === departments.length - 1) {
        const lastPct = 100 - runningTotal
        percentages.push(lastPct)
      } else {
        const exactPct = (deptQty / totalQty) * 100
        const pct = Math.ceil(exactPct)
        percentages.push(pct)
        runningTotal += pct
      }
    }

    return percentages
  }

  const getApportionmentPercentage = (index: number): number => {
    const percentages = calcApportionmentPercentages(usedDepartmentDataState)
    return percentages[index] ?? 0
  }

  const calcUnitPrice = (boa, qty) => {
    if (qty === 0 || qty === null || qty === undefined) {
      return 0
    }
    return boa / qty
  }

  const calcResidualValue = (boa, residualPercentage) => {
    return boa * (parseFloat(residualPercentage) / 100)
  }

  const calcDepreciableAmount = (boa, residualValue) => {
    return Math.max(0, boa - residualValue)
  }

  const calcOpeningNetBookValue = (boa, openingAccumulatedDepreciation) => {
    return Math.max(0, boa - (openingAccumulatedDepreciation || 0))
  }

  const validateOpeningAccumulatedDepreciation = (
    boa,
    residualValue,
    openingAccDep
  ) => {
    const maxDepreciable = boa - residualValue
    if (openingAccDep > maxDepreciable) {
      return {
        isValid: false,
        message: `Opening Accumulated Depreciation (${amtStr(
          openingAccDep
        )}) cannot exceed Depreciable Amount (${amtStr(maxDepreciable)})`,
      }
    }
    return { isValid: true, message: '' }
  }

  const calcNetAmount = (boa, residualValue) => {
    return calcDepreciableAmount(boa, residualValue)
  }

  const updateParentCalculations = (currentList: any[]) => {
    const totalQty = calcTotalQuantity(currentList)
    setValue('Quantity', totalQty)
    let rawBoa = getValues('BaseOriginalAmount')
    const currentBoa =
      typeof rawBoa === 'string'
        ? parseFloat(rawBoa.replace(/,/g, ''))
        : rawBoa ?? 0
    const currentResidualPct = getValues('Residual') ?? 0
    const newUnitPrice = calcUnitPrice(currentBoa, totalQty)
    const newResidualVal = calcResidualValue(currentBoa, currentResidualPct)
    const newNetAmount = calcNetAmount(currentBoa, newResidualVal)
    setValue('UnitPrice', newUnitPrice)
    setValue('ResidualValue', newResidualVal)
    setValue('NetAmount', newNetAmount)
    setUsedDepartmentData([...currentList])
  }

  const handleBaseOriginalAmtChange = event => {
    const newBoa = event.value || 0

    setBaseOriginalAmount(newBoa)
    setValue('BaseOriginalAmount', newBoa)

    // Recalculate residual value based on current residual %
    const currentResidualPercent = getValues('Residual') || 0
    const calculatedResidualValue = (newBoa * currentResidualPercent) / 100
    setValue('ResidualValue', calculatedResidualValue)

    // Recalculate net amount
    const newNetAmount = newBoa - calculatedResidualValue
    setValue('NetAmount', newNetAmount)

    updateParentCalculations(usedDepartmentDataState)
  }

  // Bidirectional calculation handlers for residual % and residual value
  const handleResidualPercentChange = (value: number) => {
    if (isUpdatingResidual.current) return
    isUpdatingResidual.current = true

    try {
      if (value === null || value === undefined) {
        setValue('Residual', 0)
        setValue('ResidualValue', 0)
        setValue('NetAmount', getValues('BaseOriginalAmount') || 0)
      } else {
        const rawBoa = getValues('BaseOriginalAmount')
        const boa =
          typeof rawBoa === 'string'
            ? parseFloat(rawBoa.replace(/,/g, ''))
            : rawBoa ?? 0

        setValue('Residual', value)
        const calculatedResidualValue = (boa * value) / 100
        setValue('ResidualValue', calculatedResidualValue)

        // Update net amount
        const newNetAmount = boa - calculatedResidualValue
        setValue('NetAmount', newNetAmount)
      }
    } finally {
      isUpdatingResidual.current = false
    }
  }

  const handleResidualValueChange = (value: number) => {
    if (isUpdatingResidual.current) return
    isUpdatingResidual.current = true

    try {
      if (value === null || value === undefined) {
        setValue('ResidualValue', 0)
        setValue('Residual', 0)
        setValue('NetAmount', getValues('BaseOriginalAmount') || 0)
      } else {
        const rawBoa = getValues('BaseOriginalAmount')
        const boa =
          typeof rawBoa === 'string'
            ? parseFloat(rawBoa.replace(/,/g, ''))
            : rawBoa ?? 0

        setValue('ResidualValue', value)

        if (boa > 0) {
          const calculatedResidualPercent = (value / boa) * 100
          setValue('Residual', calculatedResidualPercent)
        } else {
          setValue('Residual', 0)
        }

        // Update net amount
        const newNetAmount = boa - value
        setValue('NetAmount', newNetAmount)
      }
    } finally {
      isUpdatingResidual.current = false
    }
  }

  /* -------------------------------------------- */
  /*                      HOOK                    */
  /* -------------------------------------------- */

  const {
    anchorEl,
    setAnchorEl,
    menu,
    handleClick,
    handleClose,
  } = useMenuOption()

  const {
    anchorEl: anchorElInfo,
    setAnchorEl: setAnchorElInfo,
    menu: menuInfo,
    handleClick: handleClickInfo,
    handleClose: handleCloseInfo,
  } = useMenuOption()

  const [isAdditionalInformation, setIsAdditionalInformation] = useState(() => {
    if (mode === 'edit' && editData?.AdditionalFieldsValue?.length > 0) {
      return true
    }
    return false
  })

  /* -------------------------------------------- */
  /*                   USE FORM                   */
  /* -------------------------------------------- */
  const AssetsRegistrationFormSchema = yup.object().shape({
    RegistrationDate: yup.string().required('Registration Date is Required'),
    StartUsingDate: yup.string().required('Start Using Date is Required'),
    AssetCardNo: CommonYupValidation.requireField(SystemMsgs.assetCardNo()),
    AssetName: CommonYupValidation.requireField(SystemMsgs.AssetName()),
    AssetCategoryID: CommonYupValidation.requireField(
      SystemMsgs.AssetCategory()
    ),
    SourceID: CommonYupValidation.requireField(SystemMsgs.Source()),
    BaseOriginalAmount: yup
      .number()
      .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          const cleanedString = originalValue.replace(/,/g, '')

          if (cleanedString === '') {
            return undefined
          }

          return parseFloat(cleanedString)
        }
        return value
      })
      .moreThan(0.0, 'Base Original Amount cannot less than 0.01')
      .typeError('Base Original Amount is required')
      .required('Base Original Amount is required'),
    UOMID: CommonYupValidation.requireField(SystemMsgs.uom()),
    Remarks: CommonYupValidation.requireField(SystemMsgs.remark()),
    MethodID: isDepreciable
      ? yup
          .string()
          .nullable()
          .required('Method is Required')
      : yup.string().nullable(),

    StartYear: isDepreciable
      ? yup
          .string()
          .nullable()
          .required(SystemMsgs.startYear())
      : yup.string().nullable(),

    StartPeriod: isDepreciable
      ? yup
          .string()
          .nullable()
          .required(SystemMsgs.startPeriod())
      : yup.string().nullable(),

    UsefulLife: isDepreciable
      ? yup
          .string()
          .nullable()
          .required(SystemMsgs.usefulLife())
      : yup.string().nullable(),

    UtilizedUsefulLife: yup.string().nullable(),

    TemplateID: isAdditionalInformation
      ? yup
          .string()
          .nullable()
          .required('Template is Required')
          .test(
            'records-exist',
            'Please insert a record based on the template you choose',
            value => (value ? additionalInfoDataState.length > 0 : true)
          )
      : yup.string().nullable(),
  })

  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    watch,
    getValues,
    trigger,
    formState: { isDirty },
  } = useForm<AssetsRegistrationProps>({
    defaultValues: {
      RegistrationDate: editData ? editData?.registration_date : new Date(),
      StartUsingDate: editData ? editData?.start_use_date : new Date(),
      AssetCardNo: editData ? editData?.asset_card_no : '',
      AssetName: editData ? editData?.name : '',
      AssetCategoryID: editData ? editData?.fa_category_id : '',
      SourceID: editData ? editData?.fa_source_id : '',
      BaseOriginalAmount: editData ? editData?.base_original_amount : 0,
      Quantity: editData ? editData?.quantity : 0,
      Residual: editData ? editData?.residual : 0,
      ResidualValue: editData ? editData?.residual_value : 0,
      NetAmount: editData ? editData?.original_net_amount : 0,
      UOMID: editData ? editData?.uom_id : '',
      ModelNo: editData ? editData?.model_no : '',
      ReferenceNo: editData ? editData?.ref_no : '',
      Remarks: editData ? editData?.remark : '',
      Depreciable: editData ? editData?.is_depreciable : false,
      MethodID: editData ? editData?.fa_depreciation_method_id : '',
      StartYear: editData ? editData?.depreciation_start_year : '',
      StartPeriod: editData ? editData?.depreciation_start_period : '',
      DepreciationAmt: editData
        ? editData?.opening_accumulated_depreciation
        : 0,
      UsefulLife: editData ? editData?.opening_depreciation_useful_life : 0,
      UtilizedUsefulLife: editData
        ? editData?.depreciation_utilized_useful_life
        : 0,
      TemplateID: editData ? editData?.fa_fields_setting_id : '',
    },
    mode: 'onSubmit',
    resolver: yupResolver(AssetsRegistrationFormSchema),
  })

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  const [
    fetchSelectedAccountPeriod,
    {
      loading: selectedAccountPeriodLoading,
      data: { getSelectedAccountPeriod } = {
        getSelectedAccountPeriod: {} as any,
      },
    },
  ] = useGetSelectedAccountPeriodLazyQuery({
    fetchPolicy: 'network-only',
  })

  const {
    loading: openPeriodCheckDateLoading,
    data: { latestOpenPeriodCheckingDate } = {
      latestOpenPeriodCheckingDate: {} as any,
    },
  } = useLatestOpenPeriodCheckingDateQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  const {
    loading: accountPeriodLoading,
    error: accountPeriodError,
    data: { getAccountPeriod } = { getAccountPeriod: [] },
  } = useGetAccountPeriodQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID, orderByAsc: 'FPeriod' },
    onCompleted: ({ getAccountPeriod }) => {
      let temp = new Set()
      getAccountPeriod?.map(x => {
        temp.add(x?.FYear)
      })
      setAccPeriodYears(temp)
    },
  })

  const {
    loading: uomLoading,
    error: uomError,
    data: { getUOM } = { getUOM: [] },
  } = useGetUomQuery({
    fetchPolicy: 'network-only',
    variables: { orderByAsc: 'Name' },
  })

  const {
    loading: getFASourceLoading,
    data: { getFASource } = { getFASource: [] },
  } = useGetFaSourceQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: FieldsSettingTemplateLoading,
    data: { getFieldsSettingTemplate } = { getFieldsSettingTemplate: [] },
  } = useGetFieldsSettingTemplateQuery({
    fetchPolicy: 'network-only',
    variables: { fa_fields_setting_id: editData?.fa_fields_setting_id },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: FACategoryListingLoading,
    data: { getFACategoryDropdownListing } = {
      getFACategoryDropdownListing: [],
    },
  } = useGetFaCategoryDropdownListingQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: getFALocationLoading,
    data: { getFALocation } = { getFALocation: [] },
  } = useGetFaLocationQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID },

    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const {
    loading: getFADepreciationLoading,
    data: { getFADepreciation } = { getFADepreciation: [] },
  } = useGetFaDepreciationQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    fetchFieldSettingDetail,
    {
      loading: fieldsSettingLoading,
      data: { getFieldsSetting } = { getFieldsSetting: [] },
    },
  ] = useGetFieldsSettingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    createAsset,
    {
      loading: assetRegistrationEntryLoading,
      data: { assetRegistrationEntry } = { assetRegistrationEntry: [] },
    },
  ] = useAssetRegistrationEntryMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setTimeout(() => {
        history.push({
          pathname: `/fixed-assets/${CompanyID}/assets-registration`,
          state: { success: true, msgMode: 'create' },
        })
      }, 500)
    },
  })

  /* -------------------------------------------- */
  /*                  ATTACHMENT                  */
  /* -------------------------------------------- */

  const {
    files,
    setFiles,
    setPreviewFiles,
    handleUploadChange,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
  } = useUploadAttachment()

  const [
    fetchDocuments,
    {
      loading: DocumentLoading,
      data: { DocumentListing } = { DocumentListing: [] },
    },
  ] = useDocumentListingLazyQuery({
    fetchPolicy: 'network-only',
    variables: { refID: AssetsRegistrationID },
    onCompleted: ({ DocumentListing }) => {
      if (!editData?.files) {
        handleEditUpload(
          DocumentListing?.filter(doc => doc?.description !== 'document_pdf')
        )
        previewFiles?.push(
          ...DocumentListing?.filter(
            doc => doc?.description !== 'document_pdf'
          )?.map(x => x?.fileURL)
        )
      }
    },
  })

  useEffect(() => {
    if (
      formMode === 'edit' ||
      formMode === 'approve-reject' ||
      formMode === 'resubmit'
    )
      if (!!!editData?.files) {
        fetchDocuments({
          variables: {
            refID: AssetsRegistrationID,
          },
        })
      }
  }, [formMode])

  useEffect(() => {
    if (editData?.files) {
      setFiles(editData?.files)
      setPreviewFiles(
        editData?.files?.map(file => {
          return URL.createObjectURL(file)
        })
      )
    }
  }, [editData])

  /* -------------------------------------------- */
  /*              CHECKING/HANDLE                 */
  /* -------------------------------------------- */

  const handleDeleteItem = index => {
    if (menu?.index > -1) {
      usedDepartmentDataState.splice(menu?.index, 1)

      const newList = [...usedDepartmentDataState]
      newList.splice(menu?.index, 1)

      setUsedDepartmentData(newList)
      updateParentCalculations(newList)
    }
  }

  const handleAdditionalInformationToggle = e => {
    setValue('AdditionalInformation', e.target.checked)
    setIsAdditionalInformation(e.target.checked)

    if (!e.target.checked) {
      setSelectedTemplate(null)
      setTemplateID(null)
      setValue('TemplateID', '')
      setAdditionalInfoData([])
    }
  }
  const handleDepreciableToggle = e => {
    setValue('Depreciable', e.target.checked)
    setIsDepreciable(e.target.checked)
  }

  useEffect(() => {
    if (isDepreciable) {
      const currentMethodID = getValues('MethodID')
      const currentStartYear = getValues('StartYear')
      const currentStartPeriod = getValues('StartPeriod')
      const currentUsefulLife = getValues('UsefulLife')

      const timeoutId = setTimeout(() => {
        const fieldsToValidate = []
        if (currentMethodID) fieldsToValidate.push('MethodID')
        if (currentStartYear) fieldsToValidate.push('StartYear')
        if (currentStartPeriod) fieldsToValidate.push('StartPeriod')
        if (currentUsefulLife) fieldsToValidate.push('UsefulLife')

        if (fieldsToValidate.length > 0) {
          trigger(fieldsToValidate)
        }
      }, 100)

      return () => clearTimeout(timeoutId)
    }
  }, [isDepreciable, trigger, getValues])

  useEffect(() => {
    if (templateID) {
      fetchFieldSettingDetail({
        variables: { fa_fields_setting_id: templateID },
      })
    }
  }, [templateID])

  const formatDateInfo = date => {
    const formattedDate = new Date(date)

    const year = formattedDate.getFullYear()
    const month = String(formattedDate.getMonth() + 1).padStart(2, '0')
    const day = String(formattedDate.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  const [baseOriginalAmount, setBaseOriginalAmount] = useState(
    AssetsRegistrationID && editData?.BaseOriginalAmount
      ? parseFloat(amtNumStr(editData?.BaseOriginalAmount))
      : 0
  )

  // Ref to prevent infinite loops during bidirectional updates
  const isUpdatingResidual = React.useRef(false)

  /* -------------------------------------------- */
  /*                     SUBMIT                   */
  /* -------------------------------------------- */

  const onSubmit = async (data: any, approvalStatus: ApprovalStatus) => {
    if (approvalStatus === ApprovalStatus.Submit) {
      if (isPeriodClosed) {
        setErrMessage(
          'Cannot submit. The accounting period is closed or does not exist. ' +
            'Please select a date within the open financial period ' +
            (latestOpenPeriodCheckingDate?.StartDate &&
            latestOpenPeriodCheckingDate?.EndDate
              ? `(${latestOpenPeriodCheckingDate.StartDate} to ${latestOpenPeriodCheckingDate.EndDate}).`
              : '.')
        )
        setErrDialog(true)
        return
      }
    }

    const parseAmount = (value: any): number => {
      if (typeof value === 'number') return value
      if (typeof value === 'string') {
        return parseFloat(value.replace(/,/g, '')) || 0
      }
      return 0
    }

    const baseAmount = parseAmount(data.BaseOriginalAmount)
    const residualVal = parseAmount(data.ResidualValue)
    const calculatedNetAmount = baseAmount - residualVal

    const quantity = parseAmount(data.Quantity)
    const unitPrice = quantity > 0 ? baseAmount / quantity : 0

    const assetInput = {
      fa_asset_id: AssetsRegistrationID || null,
      company_id: CompanyID,
      asset_card_no: data.AssetCardNo || null,
      registration_date: formatDashDate(
        new Date(data?.RegistrationDate).toISOString()
      ),
      start_use_date: formatDashDate(
        new Date(data?.StartUsingDate).toISOString()
      ),
      name: data.AssetName,
      fa_fields_setting_id: isAdditionalInformation ? templateID : null,
      fa_category_id: AssetCategoryID,
      fa_source_id: SourceID,
      base_original_amount: baseAmount,
      unit_price: unitPrice,
      quantity: quantity,
      residual: parseAmount(data.Residual),
      residual_value: residualVal,
      original_net_amount: data?.NetAmount
        ? parseAmount(data.NetAmount)
        : calculatedNetAmount,
      uom_id: fetchUOMID,
      model_no: data.ModelNo || null,
      ref_no: data.ReferenceNo || null,
      remark: data.Remarks,
      is_depreciable: isDepreciable,
      fa_depreciation_method_id: isDepreciable ? MethodID : null,
      depreciation_start_year:
        isDepreciable && StartYear
          ? typeof StartYear === 'string'
            ? parseInt(StartYear)
            : StartYear
          : null,
      depreciation_start_period:
        isDepreciable && StartPeriod
          ? typeof StartPeriod === 'string'
            ? parseInt(StartPeriod)
            : StartPeriod
          : null,
      opening_accumulated_depreciation: isDepreciable
        ? parseAmount(depreciationAmt) ?? 0
        : null,
      opening_depreciation_useful_life: isDepreciable
        ? parseAmount(usefulLife) ?? 0
        : null,
      depreciation_utilized_useful_life: isDepreciable
        ? parseAmount(utilizedUsefulLife) ?? 0
        : null,
      depreciation_revaluation_amount: null,
      depreciation_provision_impairment: null,
      depreciation_reversal_impairment: null,
      ApprovalStatus: approvalStatus,
    }

    const formattedUsedDept = usedDepartmentDataState.map((item, index) => ({
      cost_centre_id: item.CostCentreID,
      quantity: parseAmount(item.Quantity),
      uom_id: fetchUOMID,
      fa_location_id: item.fa_location_id,
      sequence_no: index + 1,
    }))

    const formattedAdditionalFields = additionalInfoDataState.map(
      (item, index) => {
        const formattedAdditionalField = {}

        formattedAdditionalField['fa_fields_setting_detail_id'] =
          item.fa_fields_setting_detail_id
        formattedAdditionalField['sequence'] = index + 1

        if (item.data_type === 'NUMBER') {
          formattedAdditionalField['value_text'] = null
          formattedAdditionalField['value_number'] = parseAmount(item.value)
          formattedAdditionalField['value_date'] = null
        } else if (item.data_type === 'DATE') {
          formattedAdditionalField['value_text'] = null
          formattedAdditionalField['value_number'] = null
          formattedAdditionalField['value_date'] = formatDashDate(
            new Date(item.value).toISOString()
          )
        } else if (
          item.data_type === 'TEXT' ||
          item.control_type === 'TEXT_BOX' ||
          item.control_type === 'MULTI_LINE_TEXT_BOX'
        ) {
          formattedAdditionalField['value_text'] = String(item.value)
          formattedAdditionalField['value_number'] = null
          formattedAdditionalField['value_date'] = null
        } else {
          formattedAdditionalField['value_text'] = null
          formattedAdditionalField['value_number'] = null
          formattedAdditionalField['value_date'] = null
        }

        return formattedAdditionalField
      }
    )

    createAsset({
      variables: {
        input: {
          ...assetInput,
          File: files?.length > 0 ? files : undefined,
        },
        inputUsedDept: formattedUsedDept.length > 0 ? formattedUsedDept : [],
        inputAdditionalFields:
          formattedAdditionalFields.length > 0 ? formattedAdditionalFields : [],
      },
    })
  }

  useEffect(() => {
    if (
      editData?.AdditionalFieldsValue?.Details?.length > 0 &&
      mode === 'edit'
    ) {
      const firstDetail = editData.AdditionalFieldsValue.Details[0]
      const extractedTemplateId =
        firstDetail?.FieldsSettingDetail?.fa_fields_setting_id

      if (extractedTemplateId) {
        setTemplateID(extractedTemplateId)
        setIsAdditionalInformation(true)

        const template = getFieldsSettingTemplate?.find(
          t => t.fa_fields_setting_id === extractedTemplateId
        )
        if (template) {
          setSelectedTemplate(template)
          setValue('TemplateID', extractedTemplateId)
        }
      }
    }
  }, [editData, getFieldsSettingTemplate, mode, setValue])

  useEffect(() => {
    if (mode === 'edit' && editData?.AdditionalFieldsValue?.length > 0) {
      const extractedTemplateId =
        editData.AdditionalFieldsValue[0]?.fa_fields_setting_id

      if (extractedTemplateId) {
        setTemplateID(extractedTemplateId)
        setIsAdditionalInformation(true)
        const template = getFieldsSettingTemplate?.find(
          t => t.fa_fields_setting_id === extractedTemplateId
        )

        if (template) {
          setSelectedTemplate(template)
          setValue('TemplateID', extractedTemplateId)
        }
      }
    }
  }, [mode, editData, getFieldsSettingTemplate, setValue])

  /* -------------------------------------------- */
  /*               PERIOD VALIDATION              */
  /* -------------------------------------------- */
  const watchStartUseDate =
    watch('StartUseDate') || editData?.StartUseDate || new Date()
  const startUseDateStr = (() => {
    const d = new Date(watchStartUseDate)
    const year = d.getFullYear()
    const month = (d.getMonth() + 1).toString().padStart(2, '0')
    const day = d
      .getDate()
      .toString()
      .padStart(2, '0')
    return `${year}-${month}-${day}`
  })()

  const isPeriodClosed =
    latestOpenPeriodCheckingDate?.StartDate &&
    latestOpenPeriodCheckingDate?.EndDate
      ? startUseDateStr < latestOpenPeriodCheckingDate?.StartDate ||
        startUseDateStr > latestOpenPeriodCheckingDate?.EndDate
      : false

  /* -------------------------------------------- */
  /*                    FOOTER                    */
  /* -------------------------------------------- */
  // Validate start using date against depreciation period
  const startUseDateValidationError = useMemo(() => {
    if (!isDepreciable) return ''

    const startUsingDate = watch('StartUsingDate')
    const startYear = StartYear
    const startPeriod = StartPeriod

    if (!startUsingDate || !startYear || !startPeriod) return ''

    const selectedPeriod = getAccountPeriod?.find(
      p =>
        Number(p?.FYear) === Number(startYear) &&
        Number(p?.FPeriod) === Number(startPeriod)
    )

    if (selectedPeriod) {
      const startDate = new Date(startUsingDate)
      startDate.setHours(0, 0, 0, 0)

      const periodStartDate = new Date(selectedPeriod.StartDate)
      periodStartDate.setHours(0, 0, 0, 0)

      const periodEndDate = new Date(selectedPeriod.EndDate)
      periodEndDate.setHours(23, 59, 59, 999)

      if (startDate < periodStartDate || startDate > periodEndDate) {
        return `Start Using Date must be within the depreciation period (${formatDate(
          selectedPeriod.StartDate
        )} - ${formatDate(selectedPeriod.EndDate)}).`
      }
    }

    return ''
  }, [
    watch('StartUsingDate'),
    StartYear,
    StartPeriod,
    getAccountPeriod,
    isDepreciable,
  ])

  const draftFooterOption = {
    name: 'Save as Draft',
    onClick: () => {
      if (startUseDateValidationError) {
        setErrMessage(startUseDateValidationError)
        setErrDialog(true)
        return
      }
      handleSubmit(data => onSubmit(data, ApprovalStatus.Active))()
    },
    color: 'primary',
    props: { type: 'button' },
  }

  const rejectFooterOption = {
    name: 'Save',
    onClick: () => {
      if (startUseDateValidationError) {
        setErrMessage(startUseDateValidationError)
        setErrDialog(true)
        return
      }
      handleSubmit(data => onSubmit(data, ApprovalStatus.Active))()
    },
    color: 'primary',
    props: { type: 'button' },
    disabled: usedDepartmentDataState?.length > 0 ? false : true,
  }

  const submitFooterOption = {
    name: 'Submit',
    onClick: () => {
      if (startUseDateValidationError) {
        setErrMessage(startUseDateValidationError)
        setErrDialog(true)
        return
      }
      handleSubmit(data => onSubmit(data, ApprovalStatus.Submit))()
      setIsSubmit(true)
    },
    color: 'primary',
    props: { type: 'button' },
    disabled: usedDepartmentDataState?.length > 0 ? false : true,
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }

  return (
    <>
      {DocumentLoading && <Loading />}
      {getFALocationLoading && <Loading />}
      {fieldsSettingLoading && <Loading />}
      {accountPeriodLoading && <Loading />}
      {openPeriodCheckDateLoading && <Loading />}
      {FieldsSettingTemplateLoading && <Loading />}
      {selectedAccountPeriodLoading && <Loading />}
      {assetRegistrationEntryLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          history.push(`/fixed-assets/${CompanyID}/assets-registration`)
          localStorage.removeItem('assetsRegistration')
          localStorage.removeItem('usedDepartment')
        }}
        smTitle={'Fixed Assets'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Fixed Assets' },
          { name: 'Assets Registration', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              formMode === 'add'
                ? 'New'
                : formMode === 'approve-reject'
                ? 'Approve/Reject'
                : 'Edit',
            current: true,
          },
        ]}
      />
      <ContentWrapper float footer>
        <CardContents>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="RegistrationDate"
              label="Registration Date"
              control={control}
              ref={register}
              defaultValue={editData ? editData?.RegistrationDate : new Date()}
              allowKeyboardControl
              onAccept={(date: Date | null) => {
                fetchSelectedAccountPeriod({
                  variables: {
                    CompanyID: CompanyID,
                    selectedDate: new Date(date),
                  },
                })
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              showTodayButton
              margin="normal"
              className="left"
              value={new Date()}
              format="dd/MM/yyyy"
              required
              // minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
              // maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
              // helperText={
              //   checkingYearClose1
              //     ? 'Financial Period already closed'
              //     : errors?.RegistrationDate?.message
              // }
              // error={
              //   errors?.RegistrationDate || checkingYearClose1 ? true : false
              // }
            />
          </MuiPickersUtilsProvider>

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="StartUsingDate"
              label="Start Using Date"
              control={control}
              ref={register}
              defaultValue={editData ? editData?.StartUsingDate : new Date()}
              allowKeyboardControl
              onAccept={(date: Date | null) => {
                fetchSelectedAccountPeriod({
                  variables: {
                    CompanyID: CompanyID,
                    selectedDate: new Date(date),
                  },
                })
              }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              showTodayButton
              margin="normal"
              className="right"
              value={new Date()}
              format="dd/MM/yyyy"
              required
              // minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
              // maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
              // helperText={
              //   checkingYearClose1
              //     ? 'Financial Period already closed'
              //     : errors?.StartUsingDate?.message
              // }
              // error={
              //   errors?.StartUsingDate || checkingYearClose1 ? true : false
              // }
            />
          </MuiPickersUtilsProvider>

          <Controller
            as={TextField}
            id="standard-basic"
            name="AssetCardNo"
            label="Asset Card No"
            autoComplete="off"
            control={control}
            ref={register}
            fullWidth
            margin="dense"
            helperText={errors?.AssetCardNo?.message}
            error={errors?.AssetCardNo ? true : false}
            required
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="AssetName"
            label="Asset Name"
            autoComplete="off"
            control={control}
            ref={register}
            fullWidth
            margin="dense"
            helperText={errors?.AssetName?.message}
            error={errors?.AssetName ? true : false}
            required
          />

          {!FACategoryListingLoading && (
            <Controller
              render={({ value, onChange }) => {
                const defVal = getFACategoryDropdownListing?.filter(
                  coa => coa?.fa_category_id === editData?.fa_category_id
                )[0]
                return (
                  <Autocomplete
                    options={
                      getFACategoryDropdownListing?.sort((a, b) => {
                        return a?.name?.localeCompare(b?.name)
                      }) || []
                    }
                    getOptionLabel={option => {
                      return `${option?.name}`
                    }}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      if (!newValue) {
                        onChange('')
                        setSelectedAssetCategory(null)
                        setAssetCategoryID(null)
                        setValue('AssetCategoryID', '')
                        setValue('Residual', 0)
                        setValue('ResidualValue', 0)
                        updateParentCalculations(usedDepartmentDataState)
                      } else {
                        onChange(newValue?.fa_category_id)
                        setSelectedAssetCategory(newValue)
                        setAssetCategoryID(newValue?.fa_category_id)

                        // Set residual % and calculate residual value
                        const residualPercent = newValue?.residual || 0
                        setValue('Residual', residualPercent)

                        const rawBoa = getValues('BaseOriginalAmount')
                        const boa =
                          typeof rawBoa === 'string'
                            ? parseFloat(rawBoa.replace(/,/g, ''))
                            : rawBoa ?? 0

                        const calculatedResidualValue =
                          (boa * residualPercent) / 100
                        setValue('ResidualValue', calculatedResidualValue)

                        if (newValue?.UOMID) {
                          setFetchUOMID(newValue.UOMID)
                          setValue('UOMID', newValue.UOMID)
                          const matchedUOM = getUOM?.find(
                            uom => uom.UOMID === newValue.UOMID
                          )
                          if (matchedUOM) {
                            setSelectedUOM(matchedUOM)
                          }
                        }

                        if (newValue?.fa_depreciation_method_id) {
                          setMethodID(newValue.fa_depreciation_method_id)
                          setValue(
                            'MethodID',
                            newValue.fa_depreciation_method_id
                          )
                          const matchedMethod = getFADepreciation?.find(
                            method =>
                              method.fa_depreciation_method_id ===
                              newValue.fa_depreciation_method_id
                          )
                          if (matchedMethod) {
                            setSelectedMethod(matchedMethod)
                          }
                          if (isDepreciable) {
                            setTimeout(() => trigger('MethodID'), 0)
                          }
                        }

                        if (
                          newValue?.useful_life !== undefined &&
                          newValue?.useful_life !== null
                        ) {
                          setUsefulLife(newValue.useful_life)
                          setValue('UsefulLife', newValue.useful_life)
                        }

                        updateParentCalculations(usedDepartmentDataState)
                      }
                    }}
                    defaultValue={defVal}
                    disabled={mode === 'approve-reject'}
                    renderOption={(props, option) => {
                      return (
                        <div>
                          <div>
                            <span className="xsTitle">{props?.name}</span>
                          </div>
                        </div>
                      )
                    }}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            label="Asset Category"
                            style={{ width: '100%' }}
                            margin="normal"
                            helperText={errors?.AssetCategoryID?.message}
                            error={errors?.AssetCategoryID ? true : false}
                            required
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              name="AssetCategoryID"
              label="Asset Category"
              autoComplete="off"
              control={control}
              ref={register}
              defaultValue={editData?.fa_category_id}
              multiline={true}
              fullWidth
              margin="normal"
              helperText={errors?.AssetCategoryID?.message}
              error={errors?.AssetCategoryID ? true : false}
              required
            />
          )}

          {!getFASourceLoading && (
            <Controller
              render={({ value, onChange }) => {
                const defVal = getFASource?.filter(
                  coa => coa?.fa_source_id === editData?.fa_source_id
                )[0]
                return (
                  <Autocomplete
                    options={
                      getFASource?.sort((a, b) => {
                        return a?.name?.localeCompare(b?.name)
                      }) || []
                    }
                    getOptionLabel={option => {
                      return `${option?.name}`
                    }}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      if (!newValue) {
                        onChange('')
                        setSelectedSource(null)
                        setSourceID(null)
                        setValue('SourceID', '')
                      } else {
                        onChange(newValue?.fa_source_id)
                        setSelectedSource(newValue)
                        setSourceID(newValue?.fa_source_id)
                      }
                    }}
                    defaultValue={defVal}
                    disabled={mode === 'approve-reject'}
                    renderOption={(props, option) => {
                      return (
                        <div>
                          <div>
                            <span className="xsTitle">{props?.name}</span>
                          </div>
                        </div>
                      )
                    }}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            label="Source"
                            style={{ width: '100%' }}
                            margin="normal"
                            helperText={errors?.SourceID?.message}
                            error={errors?.SourceID ? true : false}
                            required
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              name="SourceID"
              label="Source"
              autoComplete="off"
              control={control}
              ref={register}
              defaultValue={editData?.fa_source_id}
              multiline={true}
              fullWidth
              margin="normal"
              helperText={errors?.SourceID?.message}
              error={errors?.SourceID ? true : false}
              required
            />
          )}

          <Controller
            as={<NumberFormat allowNegative={false} />}
            customInput={TextField}
            id="standard-basic"
            name="BaseOriginalAmount"
            label="Base Original Amount"
            autoComplete="off"
            control={control}
            ref={register}
            value={baseOriginalAmount}
            onValueChange={e => {
              handleBaseOriginalAmtChange(e)
            }}
            thousandSeparator
            decimalScale={2}
            fixedDecimalScale
            margin="normal"
            helperText={errors?.BaseOriginalAmount?.message}
            error={errors?.BaseOriginalAmount ? true : false}
            required
          />

          <TextField
            label="Unit Price"
            value={(() => {
              const qty = watch('Quantity') || 0
              const rawBoa = getValues('BaseOriginalAmount')
              const boa =
                typeof rawBoa === 'string'
                  ? parseFloat(rawBoa.replace(/,/g, ''))
                  : rawBoa ?? 0

              if (qty === 0) return '0.00'

              return amtStr((boa / qty).toFixed(2))
            })()}
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
            margin="dense"
            className="left"
            disabled
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            customInput={TextField}
            name="Quantity"
            label="Quantity"
            control={control}
            ref={register}
            defaultValue={menu?.obj?.Quantity ?? 0}
            decimalScale={2}
            thousandSeparator
            fixedDecimalScale
            margin="dense"
            className="right"
            InputProps={{
              disableUnderline: true,
              readOnly: true,
            }}
            disabled
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            customInput={TextField}
            name="Residual"
            label="Residual (%)"
            control={control}
            ref={register}
            value={watch('Residual') ?? 0}
            thousandSeparator
            decimalScale={4}
            fixedDecimalScale
            margin="dense"
            className="left"
            onValueChange={e => {
              handleResidualPercentChange(e.floatValue ?? 0)
            }}
          />

          <Controller
            as={<NumberFormat allowNegative={false} />}
            customInput={TextField}
            name="ResidualValue"
            label="Residual Value"
            control={control}
            ref={register}
            value={watch('ResidualValue') ?? 0}
            thousandSeparator
            decimalScale={2}
            fixedDecimalScale
            margin="dense"
            className="right"
            onValueChange={e => {
              handleResidualValueChange(e.floatValue ?? 0)
            }}
          />

          <Grid spacing={1} container className="table-content">
            <Grid item xs={6} style={{ placeSelf: 'start' }}>
              <Controller
                as={<NumberFormat allowNegative={false} />}
                customInput={TextField}
                name="NetAmount"
                label="Net Amount"
                control={control}
                ref={register}
                defaultValue={menu?.obj?.NetAmount ?? 0}
                thousandSeparator
                decimalScale={2}
                fixedDecimalScale
                margin="dense"
                className="left"
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                disabled
              />
            </Grid>

            <Grid item xs={6} style={{ placeSelf: 'start' }}>
              {!uomLoading && (
                <Controller
                  render={({ value, onChange }) => {
                    const defVal = getUOM?.filter(
                      x => x?.UOMID === editData?.uom_id
                    )[0]
                    return (
                      <Autocomplete
                        options={
                          getUOM?.sort((a, b) => {
                            return a.Code.localeCompare(b.Code)
                          }) || []
                        }
                        getOptionLabel={option => `${option?.Code}`}
                        filterOptions={createFilterOptions({
                          stringify: option => option.Code + option.Name,
                        })}
                        fullWidth
                        value={selectedUOM || defVal || null}
                        onChange={(value, newValue: any) => {
                          if (!newValue) {
                            onChange('')
                            setSelectedUOM(null)
                            setFetchUOMID(null)
                            setValue('UOMID', '')
                          } else {
                            onChange(newValue?.UOMID)
                            setSelectedUOM(newValue)
                            setFetchUOMID(newValue?.UOMID)
                          }
                        }}
                        renderOption={(props, option) => {
                          return (
                            <div>
                              <div>
                                <span className="xsTitle">{props?.Code}</span>
                              </div>
                              <div className="desc">{props?.Name}</div>
                            </div>
                          )
                        }}
                        disabled={editData?.IsUse === true ? true : false}
                        renderInput={(params: any) => {
                          return (
                            <div>
                              <TextField
                                {...params}
                                label="UOM"
                                margin="dense"
                                helperText={errors?.UOMID?.message}
                                error={errors?.UOMID ? true : false}
                                required
                              />
                            </div>
                          )
                        }}
                      />
                    )
                  }}
                  name="UOMID"
                  label="UOM"
                  autoComplete="off"
                  control={control}
                  ref={register}
                  defaultValue={editData?.UOMID}
                  multiline={true}
                  fullWidth
                  margin="dense"
                  className="right"
                  helperText={errors?.UOMID?.message}
                  error={errors?.UOMID ? true : false}
                  required
                />
              )}
            </Grid>
          </Grid>

          <Controller
            as={TextField}
            id="standard-basic"
            name="ModelNo"
            label="Model No."
            autoComplete="off"
            control={control}
            ref={register}
            fullWidth
            margin="dense"
            className="left"
          />

          <Controller
            as={TextField}
            id="standard-basic"
            name="ReferenceNo"
            label="Reference No."
            autoComplete="off"
            control={control}
            ref={register}
            fullWidth
            margin="dense"
            className="right"
          />

          <VoiceTextField
            mounted={true}
            label="Remarks"
            name="Remarks"
            setValue={setValue}
            record={record}
            setRecord={setRecord}
            setIsFormDirty={setIsFormDirty}
            control={control}
            controllerProps={{
              error: errors?.Remarks ? true : false,
              helperText: errors?.Remarks?.message,
              ref: register,
              autoComplete: 'off',
            }}
            required
          />

          <div
            style={{ width: '100%', marginTop: '24px', marginBottom: '12px' }}
          >
            <FileUploadInput
              placeholder={previewFiles.length === 0 ? 'Attachment' : null}
              label={previewFiles.length > 0 ? 'Attachment' : null}
              files={files}
              onHandleUploadChange={handleUploadChange}
              multiple
              accept={
                '.png, .jpg, .jpeg, .gif, .mp4, .avi, .mkv, .mov, .flv, .3gp, application/msword, application/pdf, application/vnd.ms-excel, application/*, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              }
              imagePreview={
                <>
                  {previewFiles?.map((v, i) => (
                    <UploadPreview
                      remove
                      key={v}
                      src={v}
                      onClick={() => removeFile(i)}
                      mediaType={
                        files[i]?.type ?? DocumentListing[i]?.mediaType
                      }
                    />
                  ))}
                </>
              }
            />
          </div>
        </CardContents>

        <CardContents
          section={{
            header: {
              title: 'Depreciation',
              icon:
                formMode === 'add' || formMode === 'edit' ? (
                  <div style={{ marginBottom: '-8px' }}>
                    <Switch
                      name="Depreciable"
                      color="primary"
                      inputRef={register()}
                      checked={isDepreciable}
                      onChange={handleDepreciableToggle}
                      style={{
                        width: '1.2rem',
                        height: '1.1rem',
                        background: theme.palette.primary.main,
                        boxShadow: `1px 1px 2px 0px ${theme.palette.primary.main}`,
                        borderRadius: '-1px',
                        color: 'rgba(224,234,254,100)',
                        marginTop: `10px`,
                        marginLeft: `10px`,
                        marginBottom: '-8px',
                      }}
                    />
                  </div>
                ) : null,
            },
          }}
        >
          {isDepreciable && (
            <AssetsRegisterDepreciationComponent
              editData={editData}
              mode={mode}
              watch={watch}
              setValue={setValue}
              trigger={trigger}
              errors={errors}
              control={control}
              register={register}
              accPeriodYears={accPeriodYears}
              getAccountPeriod={getAccountPeriod}
              AssetsRegistrationID={AssetsRegistrationID}
              depreciationAmt={depreciationAmt}
              usefulLife={usefulLife}
              utilizedUsefulLife={utilizedUsefulLife}
              getFADepreciation={getFADepreciation}
              getFADepreciationLoading={getFADepreciationLoading}
              accountPeriodLoading={accountPeriodLoading}
              selectedMethod={selectedMethod}
              setSelectedMethod={setSelectedMethod}
              MethodID={MethodID}
              setMethodID={setMethodID}
              setStartYear={setStartYear}
              setStartPeriod={setStartPeriod}
              setDepreciationAmt={setDepreciationAmt}
              setUsefulLife={setUsefulLife}
              setUtilizedUsefulLife={setUtilizedUsefulLife}
              baseOriginalAmount={watch('BaseOriginalAmount')}
              residualValue={watch('ResidualValue')}
            />
          )}
        </CardContents>

        <CardContents
          section={{
            header: {
              title: 'Used Department',
              onClickAction: () => {
                setDepartmentMode('add')
                setOpenUsedDepartment(true)
              },

              icon:
                formMode === 'add' || formMode === 'edit' ? (
                  <AddIcon
                    htmlColor="white"
                    fontSize="default"
                    style={{
                      width: '1.3rem',
                      height: '1.3rem',
                      margin: '0',
                      background: theme.palette.primary.main,
                      boxShadow: `1px 1px 4px 0px ${theme.palette.primary.main}`,
                      borderRadius: '3px',
                      color: 'rgba(224,234,254,100)',
                      marginTop: '10px',
                    }}
                  />
                ) : null,
            },
          }}
        >
          <div className="rm-padding table-wrap ">
            {usedDepartmentDataState === undefined ||
            usedDepartmentDataState?.length === 0 ? (
              <EmptyList
                title="No Record Found"
                subtitle="Add New Record now."
              />
            ) : (
              <>
                {usedDepartmentDataState
                  ?.sort(function(a, b) {
                    return a?.Sequence < b?.Sequence ? -1 : 1
                  })
                  ?.map((v, index) => {
                    const apportionPct = getApportionmentPercentage(index)
                    return (
                      <React.Fragment key={v?.UsedDepartmentID || index}>
                        <Grid spacing={1} container className="table-content">
                          <Grid item xs={1} style={{ placeSelf: 'start' }}>
                            <span className="xxTitle">{`${index + 1}.`}</span>
                          </Grid>

                          <Grid
                            item
                            xs={5}
                            style={{
                              placeSelf: 'start',
                              marginTop: '8px',
                            }}
                          >
                            <div className="xxTitle text-noflow">
                              {v?.CostCentreName}
                            </div>
                            <div className="desc text-noflow">
                              {v?.LocationName}
                            </div>
                            <div className="desc text-noflow">{v?.UOMID}</div>
                          </Grid>

                          <Grid
                            item
                            xs={2}
                            style={{
                              placeSelf: 'start',
                              marginTop: '8px',
                              textAlign: 'center',
                            }}
                          >
                            <div
                              style={{
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '11px',
                                fontWeight: 600,
                                color: '#757575',
                              }}
                            >
                              {apportionPct.toFixed(2)}%
                            </div>
                          </Grid>

                          <Grid
                            item
                            xs={3}
                            style={{
                              placeSelf: 'start',
                              marginTop: '8px',
                              marginRight: 'auto',
                            }}
                          >
                            <Grid
                              container
                              spacing={1}
                              justifyContent="flex-end"
                              alignItems="center"
                            >
                              <Grid item>
                                <div className="xxTitle">{`Qty: ${v?.Quantity}`}</div>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={1} style={{ marginTop: '0px' }}>
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              aria-controls="menu-list"
                              aria-haspopup="true"
                              onClick={e =>
                                handleClick(e, v?.UsedDepartmentID, index, v)
                              }
                            >
                              <MoreVert />
                            </IconButton>
                          </Grid>
                        </Grid>

                        <Divider
                          variant="fullWidth"
                          style={{ background: '#E4E4E4' }}
                        />
                      </React.Fragment>
                    )
                  })}
              </>
            )}
          </div>
        </CardContents>

        {!!openUsedDepartment && (
          <AssetsRegisterUsedDepartment
            openUsedDepartment={openUsedDepartment}
            formMode={formMode}
            detailMode={DepartmentMode}
            menu={menu}
            updateParentCalculations={updateParentCalculations}
            usedDepartmentData={usedDepartmentDataState}
            CompanyID={CompanyID}
            AssetsRegistrationID={AssetsRegistrationID}
            UsedDepartmentID={
              DepartmentMode === 'edit' ? menu?.obj?.UsedDepartmentID : ''
            }
            getUOM={getUOM}
            getFALocation={getFALocation}
            fetchUOMID={fetchUOMID}
            setFetchUOMID={setFetchUOMID}
            setOpenUsedDepartment={setOpenUsedDepartment}
          />
        )}

        <CardContents
          section={{
            header: {
              title: 'Additional Information',
              icon: (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '-8px',
                  }}
                >
                  {formMode === 'add' || formMode === 'edit' ? (
                    <>
                      {isAdditionalInformation &&
                        additionalInfoDataState?.length > 0 && (
                          <>
                            <VisibilityIcon
                              style={{
                                backgroundColor: theme.palette.primary.main,
                                borderRadius: '4px',
                                width: '18px',
                                height: '18px',
                                textAlign: 'center',
                                color: 'white',
                                padding: 0,
                                fontSize: '10px',
                                zIndex: 5,
                                paddingBottom: '2px',
                                cursor: 'pointer',
                                marginRight: '4px',
                              }}
                              fontSize="small"
                              onClick={() => {
                                setAdditionalInfoMode('preview')
                                setOpenAdditionalInfo(true)
                              }}
                            />
                            <EditIcon
                              style={{
                                backgroundColor: theme.palette.primary.main,
                                borderRadius: '4px',
                                width: '18px',
                                height: '18px',
                                textAlign: 'center',
                                color: 'white',
                                padding: 0,
                                fontSize: '10px',
                                zIndex: 5,
                                paddingBottom: '2px',
                                cursor: 'pointer',
                                marginRight: '4px',
                              }}
                              fontSize="small"
                              onClick={() => {
                                setAdditionalInfoMode('edit')
                                setOpenAdditionalInfo(true)
                              }}
                            />
                            <DeleteIcon
                              style={{
                                backgroundColor: '#FF1B40',
                                borderRadius: '4px',
                                width: '18px',
                                height: '18px',
                                textAlign: 'center',
                                color: 'white',
                                padding: 0,
                                fontSize: '10px',
                                zIndex: 5,
                                paddingBottom: '2px',
                                cursor: 'pointer',
                              }}
                              fontSize="small"
                              onClick={() => {
                                setAdditionalInfoData([])
                                setSelectedTemplate(null)
                                setTemplateID(null)
                                setValue('TemplateID', '')
                              }}
                            />
                          </>
                        )}

                      <Switch
                        name="AdditionalInformation"
                        color="primary"
                        inputRef={register()}
                        checked={isAdditionalInformation}
                        onChange={handleAdditionalInformationToggle}
                        style={{
                          width: '1.2rem',
                          height: '1.1rem',
                          background: theme.palette.primary.main,
                          boxShadow: `1px 1px 2px 0px ${theme.palette.primary.main}`,
                          borderRadius: '-1px',
                          color: 'rgba(224,234,254,100)',
                          marginTop: '10px',
                          marginLeft: '10px',
                        }}
                      />
                    </>
                  ) : null}
                </div>
              ),
            },
          }}
        >
          <>
            {isAdditionalInformation && (
              <>
                <Controller
                  render={({ value, onChange }) => {
                    const defVal = getFieldsSettingTemplate?.find(
                      template => template?.fa_fields_setting_id === templateID
                    )

                    return (
                      <Autocomplete
                        options={getFieldsSettingTemplate || []}
                        getOptionLabel={option => option?.name || ''}
                        fullWidth
                        value={selectedTemplate || defVal || null}
                        onChange={(event, newValue: any) => {
                          if (!newValue) {
                            onChange('')
                            setSelectedTemplate(null)
                            setTemplateID(null)
                            setValue('TemplateID', '')
                            setAdditionalInfoData([])
                          } else {
                            onChange(newValue?.fa_fields_setting_id)
                            setSelectedTemplate(newValue)
                            setTemplateID(newValue?.fa_fields_setting_id)
                            setValue(
                              'TemplateID',
                              newValue?.fa_fields_setting_id
                            )
                            setAdditionalInfoData([])
                          }
                        }}
                        disabled={mode === 'approve-reject'}
                        renderInput={(params: any) => {
                          return (
                            <TextField
                              {...params}
                              label="Select Template"
                              style={{ width: '100%' }}
                              margin="normal"
                              helperText={errors?.TemplateID?.message}
                              error={errors?.TemplateID ? true : false}
                              required
                            />
                          )
                        }}
                      />
                    )
                  }}
                  name="TemplateID"
                  label="Select Template"
                  autoComplete="off"
                  control={control}
                  ref={register}
                  defaultValue={templateID || ''}
                  fullWidth
                  margin="normal"
                  helperText={errors?.TemplateID?.message}
                  error={errors?.TemplateID ? true : false}
                  required
                />

                <AssetsRegisterAddInfoComponent
                  openAdditonalInfo={openAdditonalInfo}
                  editData={editData}
                  formMode={formMode}
                  detailMode={AdditonalInfoMode}
                  menu={menuInfo}
                  CompanyID={CompanyID}
                  AssetsRegistrationID={AssetsRegistrationID}
                  listEl={getFieldsSetting}
                  additionalInfoData={additionalInfoDataState}
                  latestOpenPeriodCheckingDate={latestOpenPeriodCheckingDate}
                  fetchSelectedAccountPeriod={fetchSelectedAccountPeriod}
                  setOpenAdditionalInfo={setOpenAdditionalInfo}
                  setAdditionalInfoData={setAdditionalInfoData}
                  setIsAdditionalInformation={setIsAdditionalInformation}
                />
              </>
            )}

            <div className="rm-padding table-wrap">
              {additionalInfoDataState === undefined ||
              additionalInfoDataState?.length === 0 ? (
                !isAdditionalInformation || !templateID ? (
                  <EmptyList
                    title="No Record Found"
                    subtitle={
                      !isAdditionalInformation
                        ? 'Turn on Additional Information to get started.'
                        : 'Select a template to add records.'
                    }
                  />
                ) : (
                  <div
                    style={{
                      padding: '40px 16px',
                      textAlign: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: '16px',
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        setAdditionalInfoMode('add')
                        setOpenAdditionalInfo(true)
                      }}
                      style={{
                        width: '56px',
                        height: '56px',
                        background: theme.palette.primary.main,
                        boxShadow: `2px 2px 8px 0px ${theme.palette.primary.main}40`,
                        borderRadius: '50%',
                        color: 'white',
                      }}
                    >
                      <AddIcon fontSize="large" />
                    </IconButton>
                    <div>
                      <div
                        style={{
                          fontSize: '14px',
                          fontWeight: 500,
                          marginBottom: '4px',
                        }}
                      >
                        No Record Found
                      </div>
                      <div style={{ fontSize: '12px', color: '#757575' }}>
                        Click the button above to add record
                      </div>
                    </div>
                  </div>
                )
              ) : (
                <>
                  {/* Header row with template name and edit button */}
                  {/* <Grid spacing={1} container className="table-content">
                    <Grid
                      item
                      xs={12}
                      style={{
                        padding: '8px 0',
                      }}
                    >
                      <div className="xxTitle" style={{ fontWeight: 'bold' }}>
                        {selectedTemplate?.name || 'Additional Information'}
                      </div>
                    </Grid>
                  </Grid> */}
                  {/* <Divider
                    variant="fullWidth"
                    style={{ background: '#E4E4E4' }}
                  /> */}

                  {/* Display all fields */}
                  {/* {additionalInfoDataState
                    ?.sort(function(a, b) {
                      return a?.sequence_no < b?.sequence_no ? -1 : 1
                    })
                    ?.map((v, index) => {
                      return (
                        <React.Fragment key={index}>
                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={12} style={{ padding: '4px 0' }}>
                              {v?.is_subgroup === true ? (
                                <span
                                  style={{
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    display: 'block',
                                    marginTop: '8px',
                                  }}
                                >
                                  {v?.Name}
                                </span>
                              ) : v?.data_type === 'DATE' ? (
                                <span style={{ fontSize: '10px' }}>
                                  {`${v?.Name}: ${formatDateInfo(v?.value)}`}
                                </span>
                              ) : v?.data_type === 'NUMBER' ? (
                                <span style={{ fontSize: '10px' }}>
                                  {`${v?.Name}: ${v?.value}`}
                                </span>
                              ) : v?.control_type === 'TEXT_BOX' ||
                                v?.control_type === 'MULTIPLE_ROW_TEXT' ? (
                                <span style={{ fontSize: '10px' }}>
                                  {`${v?.Name}: ${v?.value || ''}`}
                                </span>
                              ) : null}
                            </Grid>
                          </Grid>
                          {v?.is_subgroup === true && (
                            <Divider
                              variant="fullWidth"
                              style={{
                                background: '#E4E4E4',
                                marginTop: '4px',
                              }}
                            />
                          )}
                        </React.Fragment>
                      )
                    })} */}
                </>
              )}
            </div>
          </>
        </CardContents>
      </ContentWrapper>
      {/* {additionalInfoDataState
        ?.sort(function(a, b) {
          return a?.Sequence < b?.Sequence ? -1 : 1
        })
        ?.map((v, index) => {
          return (
            <Grid item xs={1} style={{ marginTop: '0px' }}>
              <IconButton
                edge="end"
                aria-label="delete"
                aria-controls="menu-list"
                aria-haspopup="true"
                onClick={e => handleClickInfo(e, v?.UsedDepartmentID, index, v)}
              >
                <MoreVert />
              </IconButton>
            </Grid>
          )
        })} */}
      <Menu
        id="used-department-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            setDepartmentMode('edit')
            setOpenUsedDepartment(true)
            handleClose()
          }}
        >
          <span className="mdDesc">Edit</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDeleteItem(menu?.index)
            handleClose()
          }}
        >
          <span className="mdDesc">Delete</span>
        </MenuItem>
      </Menu>
      {footerOptions?.length > 0 && (
        <AccountFooter options={[...footerOptions]} />
      )}
      <CommonDialog
        fullWidth={true}
        open={errorDia}
        onClose={() => setErrorDia(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <>
                      <span
                        className="smTitle flex-space"
                        style={{ color: 'red' }}
                      >
                        {'Document Numbering is empty'}
                      </span>
                    </>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div>
              <span>{'Please setup Document Numbering to Submit'}</span>
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setErrorDia(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <CommonDialog
        fullWidth={true}
        maxWidth="md"
        open={openPreviewDialog}
        onClose={() => setOpenPreviewDialog(false)}
        sections={{
          header: {
            children: (
              <ListItem className="remove-padding">
                <ListItemText
                  primary={
                    <span className="smTitle">
                      {selectedTemplate?.name ||
                        'Additional Information Preview'}
                    </span>
                  }
                />
              </ListItem>
            ),
          },
          body: () => (
            <div style={{ padding: '16px' }}>
              {additionalInfoDataState?.length === 0 ? (
                <div
                  style={{
                    textAlign: 'center',
                    padding: '20px',
                    color: '#757575',
                  }}
                >
                  No records to display
                </div>
              ) : (
                additionalInfoDataState
                  ?.sort((a, b) => (a?.sequence_no < b?.sequence_no ? -1 : 1))
                  ?.map((v, index) => (
                    <React.Fragment key={index}>
                      <div style={{ marginBottom: '16px' }}>
                        {v?.is_subgroup === true ? (
                          <>
                            <div
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                marginTop: index > 0 ? '16px' : '0',
                                marginBottom: '8px',
                                color: theme.palette.primary.main,
                              }}
                            >
                              {v?.Name}
                            </div>
                            <Divider style={{ marginBottom: '8px' }} />
                          </>
                        ) : (
                          <div style={{ display: 'flex', marginBottom: '8px' }}>
                            <span
                              style={{
                                fontSize: '13px',
                                fontWeight: 500,
                                minWidth: '150px',
                                color: '#666',
                              }}
                            >
                              {v?.Name}:
                            </span>
                            <span style={{ fontSize: '13px', color: '#333' }}>
                              {v?.data_type === 'DATE'
                                ? formatDateInfo(v?.value)
                                : v?.data_type === 'NUMBER'
                                ? v?.value
                                : v?.value || '-'}
                            </span>
                          </div>
                        )}
                      </div>
                    </React.Fragment>
                  ))
              )}
            </div>
          ),
          footer: {
            actions: [
              {
                displayText: 'Close',
                props: {
                  onClick: () => setOpenPreviewDialog(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/general-ledger/${CompanyID}/journal-processing`)
          localStorage.removeItem('assetsRegistration')
          localStorage.removeItem('usedDepartment')
          localStorage.removeItem('attachment')
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Validation Error'}
      />
    </>
  )
}
